import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const DeleteProtectionTierModal = ({ isOpen, onClose, onConfirm, tier }) => {
    const bodyMessage = `
  Are you sure you want to delete this protection tier?
  <br />
  <strong>Range: ${tier?.min_value ?? ""} - ${tier?.max_value ?? ""}</strong>
  <br /><br />
  This action cannot be undone.
`;

    return (
        <ReusableModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Confirm Delete"
            bodyMessage={<div dangerouslySetInnerHTML={{ __html: bodyMessage }} />}
            confirmLabel="Delete"
            cancelLabel="Cancel"
        />
    );
};

export default DeleteProtectionTierModal;